import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import { cancel } from "./cancel/api";
import { exportPDF } from "./exportPDF/api";
import { subscriptionInstallments } from "./installments/api";
import { settleInstallments } from "./settleInstallments/api";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ISubscriptionDto,
  ISubscriptionGetAllParams,
  ISubscriptionResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISubscriptionResponse>>,
  IPathBaseParam,
  IPaginationParams & ISubscriptionGetAllParams
>("subscriptions");
const postApis = createPostApi<
  IApiResponse<ISubscriptionResponse>,
  IPathBaseParam,
  ISubscriptionDto
>("subscriptions");
const getApis = createGetApi<
  IApiResponse<ISubscriptionResponse>,
  IPathByIdParam,
  object
>("subscriptions");

export const subscriptions = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  settleInstallments,
  exportPDF,
  cancel,
  subscriptionInstallments,
};
